import * as React from "react"
import { Input as InputPrimitive } from "@base-ui/react/input"
import { cva, type VariantProps } from "class-variance-authority"

import {
  formControlFieldBase,
  formControlReadOnly,
  formControlInputVariantMap,
  type FormControlVariant,
} from "@/lib/form-control-variants"
import { cn } from "@/lib/utils"

const inputVariants = cva(
  cn("w-full min-w-0", formControlFieldBase, formControlReadOnly),
  {
    variants: {
      variant: formControlInputVariantMap,
      size: {
        sm: "h-6 px-2 py-1 text-xs",
        md: "h-10 px-4 py-3 text-base",
        lg: "h-12 px-6 py-4 text-lg",
      },
    },
    defaultVariants: {
      variant: "default",
      size: "md",
    },
  }
)

interface InputProps
  extends
    Omit<React.ComponentProps<"input">, "size" | "type">,
    VariantProps<typeof inputVariants> {
  type?: Exclude<React.HTMLInputTypeAttribute, "file">
}

function Input({ className, type, variant, size, ...props }: InputProps) {
  return (
    <InputPrimitive
      type={type}
      data-slot="input"
      className={cn(inputVariants({ variant, size }), className)}
      {...props}
    />
  )
}

// eslint-disable-next-line react-refresh/only-export-components
export { Input, inputVariants }
export type { FormControlVariant, InputProps }
